import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main/main.component';
import { Step1Component } from './step1/step1.component';
import { Step3Component } from './step3/step3.component';
import { Step4Component } from './step4/step4.component';
import { Step5Component } from './step5/step5.component';
import { CommitComponent } from './commit/commit.component';
import { ReceiptComponent } from './receipt/receipt.component';
import { PaymentComponent } from './payment/payment.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { CommitwppComponent } from './commitwpp/commitwpp.component';
import { CommitwpprefComponent } from './commitwppref/commitwppref.component';
import { PaymentwppComponent } from './paymentwpp/paymentwpp.component';

const routes: Routes = [
  { path: '', redirectTo: 'express/seleccionar' },
  { path: ':route_name/seleccionar', component: Step1Component },
  { path: ':route_name/buscando', component: Step3Component },
  { path: ':route_name/registro', component: Step4Component },
  { path: ':route_name/asientos', component: Step5Component },
  { path: ':route_name/confirmar', component: CommitComponent },
  { path: ':route_name/pago', component: PaymentComponent },
  { path: ':route_name/reservación-exitosa', component: ReceiptComponent },
  { path: 'confirmacion', component: ConfirmComponent },
  { path: 'confirmarwpp/:clave_venta', component: CommitwppComponent },
  { path: 'confirmarwppref/:clave_venta/:monto_ref', component: CommitwpprefComponent },
  { path: 'pagowpp', component: PaymentwppComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RchRoutingModule { }
